import z from "zod";
import { RequestBuilder } from "../requestBuilder";
import { ConceptChunksSchema, ConceptsSyncSchema } from "./conceptClient.types";

export const GetConceptChunksRequestConfig = new RequestBuilder({
  path: (params) => `/concepts/${params.conceptId}/chunks`,
  paramsSchema: z.object({
    conceptId: z.string(),
  }),
  responseSchema: ConceptChunksSchema,
}).withIncludeProjectId();

export const ConceptsSyncRequestConfig = new RequestBuilder({
  path: () => "/concepts-sync",
  responseSchema: ConceptsSyncSchema,
}).withIncludeProjectId();
